export default __webpack_public_path__ + "static/media/continuing-3.7b29d9ab.jpg";